export default "__VITE_ASSET__DREJf7e8__"